module.exports = __webpack_public_path__ + "img/dalion.37aa5cea.png";